import Orders from 'views/admin/orders';
import Settings from 'views/admin/settings';
import NotFound from 'views/not-found';
import { authGuard } from '../auth/auth-guard';

const routes = [
  {
    path: '/admin',
    name: 'orders',
    component: Orders,
    meta: { title: 'Ordrar' },
    beforeEnter: authGuard
  },
  {
    path: '/admin/settings',
    name: 'settings',
    component: Settings,
    meta: { title: 'Inställningar' },
    beforeEnter: authGuard
  },
  {
    name: 'not-found',
    path: '/not-found',
    meta: { title: 'Page not found' },
    component: NotFound
  },
  {
    path: '*',
    redirect: { name: 'not-found' }
  }
];

export default routes;
